import React, { useEffect, useState } from "react";
import * as core from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CreatableSelect from "react-select/creatable";
import { ManagementService } from "src/services";

const Tags = (props) => {
  const { t } = useTranslation();
  const {values, handleBlur, handleChange ,registeredBefore,disabled} = props;
  const [tagList, setTagList] = useState([]);

  useEffect(() => {
    const getTagList = async () => 
    {
      var data = [];

      await ManagementService.GET_STRINGS_VALUES("VocationalTag").then((response) => 
      {
        response.data.data.forEach((rc) => 
        {
          data.push({
            value: rc.id,
            label: rc.stringValue,
          });
        });
        setTagList(data);
      });
    };
    getTagList();
  }, []);

  const handleChangeX = (newValue, actionMeta) => 
  {
    props.setFieldValue("vocationalTagList", newValue);
  };

  // console.log(`props.registeredBefore: ${props.registeredBefore}`);

  return (
    <div id="cover" style={ disabled?{pointerEvents:'none',opacity:0.7}:null}>
    <core.Card>
      <core.CardHeader title={t("pages.workerregister.vocationaltag.stepname")} />
      <core.Divider />
      <core.CardContent>
        <core.Grid container spacing={3}>
          <core.Grid item md={12} xs={12}>
            <CreatableSelect fullWidth isMulti isClearable name="vocationaltag" 
              label={t("vocationaltag.vocationaltag")} 
              variant="outlined" 
              InputLabelProps={{ shrink: true }} 
              value={values.vocationalTagList} 
              onChange={handleChangeX}
              options={tagList} />
          </core.Grid>
          <core.Grid item md={12} xs={12}>
            <core.FormControlLabel control=
            {
              <core.Switch name="baseFields.isRegistered" 
                color="primary" 
                disabled ={registeredBefore}
                value={values.baseFields?.isRegistered}
                checked={values.baseFields?.isRegistered} 
                onBlur={handleBlur} 
                onChange={handleChange} />
            }
            label={t("vocationaltag.vocationalswitch")} />
          </core.Grid>
        </core.Grid>
        <>
          {/* Master state*/}
          <pre>{JSON.stringify(props.values, null, 2)}</pre> 
        </>
      </core.CardContent>
    </core.Card>
  </div>
  );
};

export default Tags;
